import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'

const AccountNumberRestrictionsList = props => {
    const { settings, setSettings } = props

    const { contentBabbageAccountRestriction } = settings

    return contentBabbageAccountRestriction?.length > 0 ? (
        <table className="table table-sm" data-testid="related-products-list">
            <colgroup>
                <col width="85%" />
                <col width="15%" />
            </colgroup>

            <thead>
                <tr>
                    <th>Main Account No.</th>
                    <th className="!text-right">Remove</th>
                </tr>
            </thead>

            <tbody>
                {contentBabbageAccountRestriction.map((item, index) => (
                    <tr key={`account-${index}`} data-id={`account-${index}`}>
                        <td data-testid={`account-${index}-number`}>{item.babbageAccount}</td>
                        <td className="!text-right">
                            <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                    const values = [...contentBabbageAccountRestriction]
                                    values.splice(index, 1)
                                    setSettings({
                                        ...settings,
                                        contentBabbageAccountRestriction: values,
                                    })
                                }}
                                data-testid={`account-${index}-remove`}
                                style={{
                                    backgroundColor: '#dc3545',
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    ) : (
        <p className="!text-center !my-4" data-testid="no-restrictions">
            No account number restrictions applied to this content
        </p>
    )
}
export default AccountNumberRestrictionsList
